import React, { useState, useRef, useEffect } from "react";
import logo from "../../assets/chatbot.png";
import logo1 from "../../assets/Image (3).jpg";
import {
  MessageCircle,
  Plus,
  Send,
  Menu,
  X,
  Edit2,
  Trash2,
  Bot,
  User,
  Download,
  CheckSquare,
  Square,
  Check,
} from "lucide-react";
import axiosClient from "../../api-client/AxiosClient";
import { toast } from "react-toastify";

const FalconAIChatbot = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
    const [userMappingFileId, setUserMappingFileId] = useState(null);

  const [chats, setChats] = useState([
    { id: 1, title: "New Chat", messages: [] },
  ]);
  const [activeChat, setActiveChat] = useState(1);
  const [message, setMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState({});
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chats]);

  useEffect(() => {
    const storedFileId = sessionStorage.getItem('selectedFileId');
    if (storedFileId) {
      setUserMappingFileId(parseInt(storedFileId));
    }
  }, []);

  // ✅ Add welcome message on first load
  useEffect(() => {
    setChats((prevChats) =>
      prevChats.map((chat, index) =>
        index === 0 && chat.messages.length === 0
          ? {
              ...chat,
              messages: [
                {
                  id: Date.now(),
                  sender: "ai",
                  text: `Welcome to Owlsight Data Quality Platform.
Experience automated validation, intelligent issue detection, and rich visual insights powered by AI.`,
                  timestamp: new Date(),
                  hasDownload: false,
                },
              ],
            }
          : chat
      )
    );
  }, []);

  const createNewChat = () => {
    const newChatId = Date.now();
    const newChat = {
      id: newChatId,
      title: "New Chat",
      messages: [
        // ✅ Also add welcome message for new chat
        {
          id: newChatId + 1,
          sender: "ai",
          text: `Welcome to Owlsight Data Quality Platform.
Experience automated validation, intelligent issue detection, and rich visual insights powered by AI.`,
          timestamp: new Date(),
          hasDownload: false,
        },
      ],
    };
    setChats([...chats, newChat]);
    setActiveChat(newChatId);
  };

  const deleteChat = (chatId) => {
    if (chats.length === 1) return; // Don't delete the last chat
    const updatedChats = chats.filter((chat) => chat.id !== chatId);
    setChats(updatedChats);
    if (activeChat === chatId) {
      setActiveChat(updatedChats[0].id);
    }
  };

  // 2. ADD THIS NEW FUNCTION (after downloadResponse function, before renderTableFromJSON)
  const handleRowSelect = (messageId, rowIndex) => {
    const key = `${messageId}-${rowIndex}`;
    setSelectedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSelectAll = (messageId, totalRows) => {
    const allSelected = Array.from({ length: totalRows }).every(
      (_, i) => selectedRows[`${messageId}-${i}`]
    );

    const newSelection = { ...selectedRows };
    Array.from({ length: totalRows }).forEach((_, i) => {
      newSelection[`${messageId}-${i}`] = !allSelected;
    });
    setSelectedRows(newSelection);
  };

  const getSelectedRowsForMessage = (messageId, totalRows) => {
    return Array.from({ length: totalRows }).filter(
      (_, i) => selectedRows[`${messageId}-${i}`]
    ).length;
  };

  const handleApproveSelected = async (messageId, selectedData) => {
    try {
      console.log("Approve clicked for message:", messageId);
      console.log("Selected rows data:", selectedData);

      // Transform selected data to match API schema
      const updateBulkMapperDetailsRequests = selectedData.map((row) => ({
        targetTableName: row.SAPTableName || row["SAP Table Name"] || "",
        targetFieldName: row.SAPColumnName || row["SAP Column Name"] || "",
        sourceTableName: row.AXTableName || row["AX Table Name"] || "",
        sourceFieldName: row.AXColumnName || row["AX Column Name"] || "",
      }));

     const payload = {
        updateBulkMapperDetailsRequests: updateBulkMapperDetailsRequests,
        userMappingFileId: userMappingFileId || 20, // USE THE STATE HERE
      };


      console.log("Sending payload to API:", payload);

     const response = await axiosClient.post(
      "/api/Mapper/UpdateBulkMapperFile",
      payload
    );


      console.log("Update response status:", response.status);

      // if (!response.ok) {
      //   const errorText = await response.text();
      //   console.error("Update Error Response:", errorText);
      //   throw new Error(`Update failed! status: ${response.status}`);
      // }

      // Success handling
      toast.success("Selected mappings approved and saved successfully!");
      console.log("Approval successful");

      // Optional: Clear selected rows after successful approval
      setSelectedRows({});
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error(`❌ Failed to approve mappings: ${error.message}`);
    }
  };

  const updateChatTitle = (chatId, newTitle) => {
    setChats(
      chats.map((chat) =>
        chat.id === chatId ? { ...chat, title: newTitle } : chat
      )
    );
  };

  // ✅ NEW: API integration function
  const callAgentAPI = async (query) => {
  try {
    // Create FormData for application/x-www-form-urlencoded
    const formData = new URLSearchParams();
    formData.append('prompt', query);

    const response = await fetch(
      "https://apiowlsight.bluegecko.ai:8003/chat/query",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      success: true,
      data: data,
      hasDownloadableData: false, // Text-only responses, no table download
      isTextOnly: true,
    };
  } catch (error) {
    console.error("API Error:", error);
    return {
      success: false,
      error: error.message,
      hasDownloadableData: false,
      isTextOnly: true,
    };
  }
};

  // Add this new function before the downloadResponse function
  const generateFileFromDisplayedData = (messageData, format, filename) => {
    try {
      console.log(
        "generateFileFromDisplayedData called with:",
        messageData,
        format,
        filename
      );

      let tableData = null;

      // Check if messageData is directly an array
      if (Array.isArray(messageData)) {
        tableData = messageData;
      }
      // Check for arrays in the data object dynamically
      else if (messageData && typeof messageData === "object") {
        const dataKeys = Object.keys(messageData);
        console.log("Available keys in messageData:", dataKeys);

        // Look for common array property names first
        const commonArrayKeys = [
          "results",
          "sap_columns",
          "sap_tables",
          "data",
        ];
        for (const key of commonArrayKeys) {
          if (
            messageData[key] &&
            Array.isArray(messageData[key]) &&
            messageData[key].length > 0
          ) {
            tableData = messageData[key];
            console.log(`Found data in ${key}:`, tableData);
            break;
          }
        }

        // If not found, look for any array
        if (!tableData) {
          for (const key of dataKeys) {
            if (
              Array.isArray(messageData[key]) &&
              messageData[key].length > 0
            ) {
              tableData = messageData[key];
              console.log(`Found data in ${key}:`, tableData);
              break;
            }
          }
        }
      }

      if (!tableData || !Array.isArray(tableData) || tableData.length === 0) {
        console.error("No valid array data found:", messageData);
        throw new Error(
          "No valid data to export - no arrays found in the data"
        );
      }

      if (format === "csv") {
        let csvContent;

        // Check if array contains objects or simple values
        if (typeof tableData[0] === "object" && tableData[0] !== null) {
          // Handle array of objects
          const allKeys = [
            ...new Set(tableData.flatMap((item) => Object.keys(item))),
          ];
          console.log("CSV Headers:", allKeys);

          csvContent = [
            allKeys.join(","), // Header row
            ...tableData.map((item) =>
              allKeys
                .map((header) => {
                  const value = item[header] || "";
                  return `"${String(value).replace(/"/g, '""')}"`;
                })
                .join(",")
            ),
          ].join("\n");
        } else {
          // Handle simple array
          csvContent = [
            "Index,Value", // Header row
            ...tableData.map(
              (item, index) =>
                `${index + 1},"${String(item).replace(/"/g, '""')}"`
            ),
          ].join("\n");
        }

        console.log("Generated CSV content length:", csvContent.length);

        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return { success: true };
      } else {
        throw new Error("Only CSV format is supported in fallback mode");
      }
    } catch (error) {
      console.error("generateFileFromDisplayedData error:", error);
      return { success: false, error: error.message };
    }
  };

  // ✅ NEW: Download function for AI responses
  const downloadResponse = async (query, format = "csv") => {
    try {
      console.log("Downloading with format:", format, "for query:", query);

      const timestamp = new Date()
        .toISOString()
        .slice(0, 19)
        .replace(/:/g, "-");
      const filename = `mapping_result_${timestamp}`;

      const response = await fetch(
        "https://agentapi.bluegecko.ai:8000/AgenticAIMapping",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: query,
            download_format: format,
            filename: filename,
          }),
        }
      );

      console.log("Download response status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Download Error Response:", errorText);
        throw new Error(`Download failed! status: ${response.status}`);
      }

      const contentType = response.headers.get("content-type");
      console.log("Content-Type:", contentType);

      // For CSV format
      if (format === "csv") {
        if (contentType && contentType.includes("application/json")) {
          // If API returns JSON, convert it to CSV
          const jsonData = await response.json();
          console.log("Converting JSON to CSV:", jsonData);

          let tableData = null;

          // Check for different data structures
          if (Array.isArray(jsonData)) {
            tableData = jsonData;
          } else if (jsonData.results && Array.isArray(jsonData.results)) {
            tableData = jsonData.results;
          } else if (
            jsonData.sap_columns &&
            Array.isArray(jsonData.sap_columns)
          ) {
            tableData = jsonData.sap_columns;
          } else {
            // Look for any array in the response
            const arrayKeys = Object.keys(jsonData).filter(
              (key) => Array.isArray(jsonData[key]) && jsonData[key].length > 0
            );
            if (arrayKeys.length > 0) {
              tableData = jsonData[arrayKeys[0]];
            }
          }

          if (!tableData || tableData.length === 0) {
            throw new Error(
              "No valid data found in API response for CSV conversion"
            );
          }

          // Generate CSV content
          const allKeys = [
            ...new Set(tableData.flatMap((item) => Object.keys(item))),
          ];
          const csvContent = [
            allKeys.join(","), // Header row
            ...tableData.map((item) =>
              allKeys
                .map((header) => {
                  const value = item[header] || "";
                  return `"${String(value).replace(/"/g, '""')}"`;
                })
                .join(",")
            ),
          ].join("\n");

          const blob = new Blob([csvContent], { type: "text/csv" });

          // Create and trigger download
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = `${filename}.csv`;
          document.body.appendChild(a);
          a.click();

          // Cleanup
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 100);

          return { success: true };
        } else {
          // If API returns actual CSV file
          const csvText = await response.text();
          const blob = new Blob([csvText], { type: "text/csv" });

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = `${filename}.csv`;
          document.body.appendChild(a);
          a.click();

          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 100);

          return { success: true };
        }
      }

      return { success: false, error: "Unsupported format" };
    } catch (error) {
      console.error("Download Error Details:", error);
      return {
        success: false,
        error: error.message || "Download failed due to network error",
      };
    }
  };

  const renderTableFromJSON = (data, messageId) => {
    try {
      console.log("renderTableFromJSON received data:", data);

      if (!data) {
        console.log("No data provided");
        return null;
      }

      let tableData = null;
      let tableName = "";

      // ✅ IMPROVED: More dynamic data detection
      if (Array.isArray(data)) {
        // Direct array - most common case for your API
        if (
          data.length > 0 &&
          typeof data[0] === "object" &&
          data[0] !== null
        ) {
          tableData = data;
          tableName = "Results";
        } else {
          // Array of simple values
          tableData = data.map((item, index) => ({
            Index: index + 1,
            Value: item,
          }));
          tableName = "Results";
        }
      } else if (typeof data === "object" && data !== null) {
        // Object response - check for different structures

        // Check for simple message responses first
        if (
          data.message &&
          typeof data.message === "string" &&
          Object.keys(data).length === 1
        ) {
          // Don't render table for simple messages
          return null;
        }

        if (
          data.detail &&
          typeof data.detail === "string" &&
          Object.keys(data).length === 1
        ) {
          // Don't render table for simple detail messages
          return null;
        }

        // Look for array properties in the object
        const arrayKeys = Object.keys(data).filter(
          (key) => Array.isArray(data[key]) && data[key].length > 0
        );

        if (arrayKeys.length > 0) {
          const firstArrayKey = arrayKeys[0];
          const firstArray = data[firstArrayKey];

          // Check if it's an array of objects
          if (
            firstArray[0] &&
            typeof firstArray[0] === "object" &&
            firstArray[0] !== null
          ) {
            tableData = firstArray;
            tableName = firstArrayKey
              .replace(/_/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase());
          } else {
            // Array of simple values
            tableData = firstArray.map((item, index) => ({
              Index: index + 1,
              [firstArrayKey
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase())]: item,
            }));
            tableName = firstArrayKey
              .replace(/_/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase());
          }
        } else {
          // Object with properties but no arrays - convert to key-value table
          const objectKeys = Object.keys(data);
          if (objectKeys.length > 0) {
            tableData = objectKeys.map((key) => ({
              Property: key
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase()),
              Value:
                typeof data[key] === "object" && data[key] !== null
                  ? JSON.stringify(data[key])
                  : String(data[key] || ""),
            }));
            tableName = "Details";
          }
        }
      }

      // ✅ IMPROVED: Better validation and rendering
      if (!tableData || !Array.isArray(tableData) || tableData.length === 0) {
        console.log("No valid table data found");
        return null;
      }

      // Filter out invalid items
      const validTableData = tableData.filter(
        (item) => item && typeof item === "object" && item !== null
      );

      if (validTableData.length === 0) {
        console.log("No valid table data found after filtering");
        return null;
      }

      // Get all unique keys from the data
      const allKeys = [
        ...new Set(validTableData.flatMap((item) => Object.keys(item))),
      ];

      console.log("Rendering table with headers:", allKeys);
      console.log("Table data:", validTableData);

      return (
        <div
          className={`w-full mt-3 ${
            allKeys.length > 7 ? "overflow-x-auto" : ""
          }`}
        >
          {tableName && (
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              {tableName}
            </h4>
          )}
          <table
            className={`min-w-full bg-white border border-gray-200 rounded-lg text-xs ${
              allKeys.length > 7 ? "table-fixed" : ""
            }`}
          >
            <thead className="bg-gray-50">
              <tr>
                {/* CHECKBOX HEADER */}
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b whitespace-nowrap w-12">
                  <button
                    onClick={() =>
                      handleSelectAll(messageId, validTableData.length)
                    }
                    className="text-gray-600 hover:text-blue-600 transition-colors"
                    title="Select all"
                  >
                    {Array.from({ length: validTableData.length }).every(
                      (_, i) => selectedRows[`${messageId}-${i}`]
                    ) ? (
                      <CheckSquare className="w-4 h-4 text-blue-600" />
                    ) : (
                      <Square className="w-4 h-4" />
                    )}
                  </button>
                </th>
                {allKeys.map((key, index) => (
                  <th
                    key={index}
                    className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b whitespace-nowrap"
                  >
                    {(() => {
                      // Custom mappings for specific cases
                      const headerMappings = {
                        SAPTableName: "SAP Table Name",
                        SAPColumnName: "SAP Column Name",
                        AXTableName: "AX Table Name",
                        AXColumnName: "AX Column Name",
                        ObjectName: "Object Name",
                        Description: "Description",
                        Mandatory: "Mandatory",
                      };

                      // Check if we have a specific mapping first
                      if (headerMappings[key]) {
                        return headerMappings[key];
                      }

                      // Fallback: Insert space only before lowercase-to-uppercase transitions
                      return key.replace(/([a-z])([A-Z])/g, "$1 $2");
                    })()}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {validTableData.map((item, rowIndex) => {
                const rowKey = `${messageId}-${rowIndex}`;
                const isSelected = selectedRows[rowKey];
                return (
                  <tr
                    key={rowIndex}
                    className={`hover:bg-gray-50 ${
                      isSelected ? "bg-blue-50" : ""
                    }`}
                  >
                    {/* CHECKBOX CELL */}
                    <td className="px-3 py-2 text-xs border-b w-12">
                      <button
                        onClick={() => handleRowSelect(messageId, rowIndex)}
                        className="text-gray-600 hover:text-blue-600 transition-colors"
                      >
                        {isSelected ? (
                          <CheckSquare className="w-4 h-4 text-blue-600" />
                        ) : (
                          <Square className="w-4 h-4" />
                        )}
                      </button>
                    </td>
                    {allKeys.map((key, colIndex) => {
                      const value = item[key] || "";
                      const displayValue =
                        typeof value === "object" && value !== null
                          ? JSON.stringify(value)
                          : String(value);

                      return (
                        <td
                          key={colIndex}
                          className={`px-2 py-2 text-xs text-gray-900 border-b whitespace-nowrap overflow-hidden text-ellipsis ${
                            allKeys.length > 7 ? "min-w-32" : "max-w-xs"
                          }`}
                          title={displayValue}
                        >
                          {key.toLowerCase().includes("status") ? (
                            <span
                              className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                displayValue.includes("✅") ||
                                displayValue.toLowerCase().includes("mapped")
                                  ? "bg-green-100 text-green-800"
                                  : displayValue.includes("❌") ||
                                    displayValue
                                      .toLowerCase()
                                      .includes("not mapped")
                                  ? "bg-red-100 text-red-800"
                                  : displayValue.includes("⚠️") ||
                                    displayValue
                                      .toLowerCase()
                                      .includes("partial")
                                  ? "bg-yellow-100 text-yellow-800"
                                  : "bg-gray-100 text-gray-800"
                              }`}
                            >
                              {displayValue}
                            </span>
                          ) : key.toLowerCase().includes("mandatory") ? (
                            <span
                              className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                displayValue.toLowerCase() === "yes" ||
                                displayValue.toLowerCase() === "true"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-gray-100 text-gray-800"
                              }`}
                            >
                              {displayValue}
                            </span>
                          ) : (
                            <span
                              className={
                                key.toLowerCase().includes("column") ||
                                key.toLowerCase().includes("table") ||
                                key.toLowerCase().includes("name")
                                  ? "font-medium"
                                  : ""
                              }
                            >
                              {displayValue}
                            </span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    } catch (error) {
      console.error("Error in renderTableFromJSON:", error);
      return (
        <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">
            Error rendering table data: {error.message}
          </p>
        </div>
      );
    }
  };

 const sendMessage = async () => {
  if (!message.trim()) return;

  const userMessage = {
    id: Date.now(),
    text: message,
    sender: "user",
    timestamp: new Date(),
  };

  const currentQuery = message;

  setChats((prevChats) =>
    prevChats.map((chat) =>
      chat.id === activeChat
        ? {
            ...chat,
            messages: [...chat.messages, userMessage],
            title:
              chat.messages.length <= 1
                ? message.slice(0, 30) + (message.length > 30 ? "..." : "")
                : chat.title,
          }
        : chat
    )
  );

  setMessage("");
  setIsTyping(true);

  try {
    const apiResult = await callAgentAPI(currentQuery);

    if (apiResult.success) {
      let aiResponseText = "";

      console.log("API Response Data:", apiResult.data);

      // ✅ UPDATED: Handle text-only response format
      if (apiResult.data && apiResult.data.answer) {
        // The API returns an object with answer field
        aiResponseText = apiResult.data.answer;
      } else if (typeof apiResult.data === "string") {
        aiResponseText = apiResult.data;
      } else if (apiResult.data && apiResult.data.message) {
        aiResponseText = apiResult.data.message;
      } else {
        aiResponseText = JSON.stringify(apiResult.data);
      }

      const aiResponse = {
        id: Date.now() + 1,
        text: aiResponseText,
        sender: "ai",
        timestamp: new Date(),
        hasDownload: false, // Text-only, no download
        originalQuery: currentQuery,
        data: null, // No structured data
      };

      console.log("Final AI Response:", aiResponse);

      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.id === activeChat
            ? { ...chat, messages: [...chat.messages, aiResponse] }
            : chat
        )
      );
    } else {
      const errorResponse = {
        id: Date.now() + 1,
        text: `I apologize, but I encountered an error while processing your request: ${apiResult.error}. Please try again or contact support if the issue persists.`,
        sender: "ai",
        timestamp: new Date(),
        hasDownload: false,
      };

      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.id === activeChat
            ? { ...chat, messages: [...chat.messages, errorResponse] }
            : chat
        )
      );
    }
  } catch (error) {
    const errorResponse = {
      id: Date.now() + 1,
      text: `I apologize, but I'm currently unable to process your request due to a technical issue. Please try again later.`,
      sender: "ai",
      timestamp: new Date(),
      hasDownload: false,
    };

    setChats((prevChats) =>
      prevChats.map((chat) =>
        chat.id === activeChat
          ? { ...chat, messages: [...chat.messages, errorResponse] }
          : chat
      )
    );
  } finally {
    setIsTyping(false);
  }
};
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  // ✅ NEW: Handle download button click
  const handleDownload = async (message, format) => {
    if (!message.originalQuery) return;

    const result = await downloadResponse(message.originalQuery, format);
    if (!result.success) {
      console.log("API download failed, trying fallback method...");

      // Fallback: generate file from displayed data
      if (message.data) {
        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/:/g, "-");
        const filename = `mapping_result_${timestamp}`;

        const fallbackResult = generateFileFromDisplayedData(
          message.data,
          format,
          filename
        );
        if (!fallbackResult.success) {
          toast.error(
            `Download failed: ${result.error}. Fallback also failed: ${fallbackResult.error}`
          );
        }
      } else {
        toast.error(`Download failed: ${result.error}`);
      }
    }
  };

  const currentChat = chats.find((chat) => chat.id === activeChat);

  return (
    <div className="flex bg-gray-50" style={{ height: "calc(100vh - 140px)" }}>
      {/* Sidebar */}
      <div
        className={`${
          sidebarOpen ? "w-64" : "w-0"
        } transition-all duration-300 bg-white text-gray-800 overflow-hidden flex flex-col`}
        style={{ height: "calc(100vh - 140px)" }}
      >
        <div className="p-4">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold flex items-center gap-2 text-gray-900">
              <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-white border">
                <img
                  src={logo1}
                  alt="AI Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              BlueGecko AI
            </h2>

            <button
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden text-gray-500 hover:text-gray-800"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* New Chat Button */}
          <button
            onClick={createNewChat}
            className="w-full flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg transition-colors mb-4"
          >
            <Plus className="w-4 h-4" />
            New Chat
          </button>

          {/* Chats List */}
          <div className="space-y-1 flex-1 overflow-y-auto">
            {chats.map((chat) => (
              <div
                key={chat.id}
                className={`group flex items-center justify-between p-2 rounded-lg cursor-pointer transition-colors ${
                  activeChat === chat.id
                    ? "bg-gray-200 text-gray-900" // active state (light gray background)
                    : "hover:bg-gray-100"
                }`}
                onClick={() => setActiveChat(chat.id)}
              >
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <MessageCircle className="w-4 h-4 flex-shrink-0 text-gray-600" />
                  <span className="text-sm truncate">{chat.title}</span>
                </div>
                <div className="opacity-0 group-hover:opacity-100 flex items-center gap-1">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      const newTitle = prompt("Enter new title:", chat.title);
                      if (newTitle) updateChatTitle(chat.id, newTitle);
                    }}
                    className="p-1 hover:bg-gray-200 rounded"
                  >
                    <Edit2 className="w-3 h-3 text-gray-600" />
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteChat(chat.id);
                    }}
                    className="p-1 hover:bg-red-100 rounded text-red-500"
                  >
                    <Trash2 className="w-3 h-3" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 p-4 flex items-center justify-between flex-shrink-0 sticky top-0 z-10">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="text-gray-600 hover:text-gray-800 flex items-center justify-center w-8 h-8"
            >
              <Menu className="w-5 h-5" />
            </button>
            <h1 className="text-lg font-semibold text-gray-800 leading-8">
              {currentChat?.title || "Falcon AI Chat"}
            </h1>
          </div>

          {/* Logo */}
          <div className="flex items-center gap-2">
            <img
              src={logo}
              alt="Falcon AI Logo"
              className="w-8 h-8 rounded-full object-cover cursor-pointer"
            />
          </div>
        </div>

        {/* Messages */}
        <div
          className="flex-1 p-4 space-y-4 overflow-y-auto min-h-0"
          style={{ maxHeight: "calc(100% - 140px)" }}
        >
          {currentChat?.messages.map((msg) => (
            <div
              key={msg.id}
              className={`flex gap-3 ${
                msg.sender === "user" ? "justify-end" : "justify-start"
              }`}
            >
              {msg.sender === "ai" && (
                <div className="w-8 h-8 rounded-full flex-shrink-0 overflow-hidden">
                  <img
                    src={logo1}
                    alt="AI Logo"
                    className="w-full h-full object-cover"
                  />{" "}
                </div>
              )}
              <div
                className={`${
                  msg.sender === "user" ? "max-w-3xl" : "max-w-5xl"
                }`}
              >
                <div
                  className={`px-4 py-2 rounded-lg ${
                    msg.sender === "user"
                      ? "bg-blue-500 text-white"
                      : "bg-white border border-gray-200 text-gray-800"
                  }`}
                >
                  <p className="whitespace-pre-wrap">{msg.text}</p>

                  {/* Render table for AI responses with structured data */}
                  {msg.sender === "ai" &&
                    msg.data &&
                    renderTableFromJSON(msg.data, msg.id)}

                  <span className="text-xs opacity-70 mt-1 block">
                    {msg.timestamp.toLocaleTimeString()}
                  </span>
                </div>

                {/* ✅ NEW: Download buttons for AI responses with downloadable data */}
                {msg.sender === "ai" && msg.hasDownload && (
                  <div className="mt-3 space-y-2">
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleDownload(msg, "csv")}
                        className="flex items-center gap-1 px-3 py-1 text-xs bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                      >
                        <Download className="w-3 h-3" />
                        CSV
                      </button>
                    </div>

                    {/* APPROVE BUTTON - With API Integration */}
                    {(() => {
                      const selectedCount = getSelectedRowsForMessage(
                        msg.id,
                        Array.isArray(msg.data) ? msg.data.length : 0
                      );
                      return selectedCount > 0 ? (
                        <button
                          onClick={() => {
                            const selectedRowsData = Array.isArray(msg.data)
                              ? msg.data.filter(
                                  (_, i) => selectedRows[`${msg.id}-${i}`]
                                )
                              : msg.data;
                            handleApproveSelected(msg.id, selectedRowsData);
                          }}
                          className="flex items-center gap-1 px-3 py-1 text-xs bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors"
                        >
                          <Check className="w-3 h-3" />
                          Approve Selected ({selectedCount})
                        </button>
                      ) : null;
                    })()}
                  </div>
                )}
              </div>
              {msg.sender === "user" && (
                <div className="w-8 h-8 bg-gray-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <User className="w-4 h-4 text-white" />
                </div>
              )}
            </div>
          ))}

          {isTyping && (
            <div className="flex gap-3">
              <div className="w-8 h-8 rounded-full flex-shrink-0 overflow-hidden">
                <img
                  src={logo1}
                  alt="AI Logo"
                  className="w-full h-full object-cover"
                />{" "}
              </div>
              <div className="bg-white border border-gray-200 px-4 py-2 rounded-lg">
                <div className="flex gap-1">
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
                  <div
                    className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                    style={{ animationDelay: "0.1s" }}
                  ></div>
                  <div
                    className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                    style={{ animationDelay: "0.2s" }}
                  ></div>
                </div>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* Input Area */}
        <div className="bg-white border-t border-gray-200 px-4 py-1 flex-shrink-0 sticky bottom-0 z-10">
          <div className="max-w-4xl mx-auto ">
            <div className="relative flex items-center">
              <textarea
                ref={textareaRef}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Type your message..."
                className="w-full pr-12 pl-4 py-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows="1"
                style={{ minHeight: "48px", maxHeight: "120px" }}
              />
              <button
                onClick={sendMessage}
                disabled={!message.trim() || isTyping}
                className={`absolute right-3 p-2 rounded-md transition-colors ${
                  message.trim() && !isTyping
                    ? "text-blue-500 hover:text-blue-600"
                    : "text-gray-400 cursor-not-allowed"
                }`}
              >
                <Send className="w-5 h-5" />
              </button>
            </div>

            <p className="text-xs text-gray-500  text-center">
              Press Enter to send, Shift + Enter for new line
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FalconAIChatbot;
